import * as React from 'react';

interface Props {
    score: string | number;
    base?: string | number;
};

interface State {}

export class Score extends React.Component<Props, State> {

    state: State = {}

	render() {
        const {
            score,
            base
        } = this.props;

        // Check for a null/error/missing score
        if (score === null || score === undefined) return <span>-</span>
        
        let visibleScore = score.toString();

        // Convert and detect all the various ways of representing
        // a "score" in our platform
        if (score.toString().includes(".") && (parseFloat(score.toString()) < 1.0)) {
            const baseScore = parseFloat(score.toString());

            visibleScore = Math.round(baseScore * 100.0).toString();
        }
        else {
            const baseScore = parseFloat(score.toString());
            const baseMax = parseFloat(base!.toString());

            visibleScore = Math.round((baseScore / baseMax) * 100.0).toString();
        }

        if (visibleScore.includes("NaN")) {
            return <span>
                -
            </span>
        }

        if (visibleScore === "0") {
            return <span>
                -
            </span>
        }

        return <span>{visibleScore + "%"}</span>
	}
}
